<div class="card card-no-border mt-4">
    <div class="card-header">
        <ul class="nav nav-tabs card-header-tabs" role="tablist">
            <li class="nav-item" role="presentation">
                <button type="button" class="nav-link" role="tab" id="admin-tab-sync"
                    [class.active]="activeTab() === 'sync'" [attr.aria-selected]="activeTab() === 'sync'"
                    aria-controls="admin-panel-sync" (click)="selectTab('sync')">
                    <i class="fas fa-building-flag me-1" aria-hidden="true"></i> Synkroniseringscenter
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button type="button" class="nav-link" role="tab" id="admin-tab-errors"
                    [class.active]="activeTab() === 'errors'" [attr.aria-selected]="activeTab() === 'errors'"
                    aria-controls="admin-panel-errors" (click)="selectTab('errors')">
                    <i class="fas fa-triangle-exclamation me-1" aria-hidden="true"></i> Synkroniseringsfejl
                </button>
            </li>
        </ul>
    </div>
    <div class="card-body">
        @switch (activeTab()) {
            @case ('sync') {
                <div id="admin-panel-sync" role="tabpanel" aria-labelledby="admin-tab-sync">
                    <app-synchronization-center-state />
                </div>
            }
            @case ('errors') {
                <div id="admin-panel-errors" role="tabpanel" aria-labelledby="admin-tab-errors">
                    <app-sync-error-log />
                </div>
            }
        }
    </div>
</div>
